/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from "react";
import PropTypes from "prop-types";
import shihuo from 'shihuo-lib/dist/shihuo-lib';
import utils from '../../../../../utils/utils';
import Request from "../../../../../utils/request";
import "./style.less";

class PipelineNavigationBarPopover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.pageId = utils.getPageId();
    this.ref = null;
    this.backRef = null;
    this.shareRef = null;
    this.backDarkRef = null;
    this.shareDarkRef = null;
    this.backLightRef = null;
    this.shareLightRef = null;
    this.navigationRef = null;
  }

  componentDidMount() {
    window && window.addEventListener('scroll', () => {
      let y = document.documentElement.scrollTop || document.body.scrollTop;
      y = y < 0 ? 0 : y;
      if (this.ref) {
        const opacity = y > 20 ? 1 : (y / 20).toFixed(2)
        this.ref.style.opacity = opacity;

        const { baseConfig } = this.props.config;
        if (baseConfig.navigatorBarTheme == '黑') {
          this.backDarkRef.style.opacity = opacity;
          this.shareDarkRef.style.opacity = opacity;
          this.backLightRef.style.opacity = 1 - opacity;
          this.shareLightRef.style.opacity = 1 - opacity;
        }
      }
      if (this.backRef) {
        const opacity = y > 20 ? 0 : (1 - (y / 20).toFixed(2)) * 0.2;
        this.backRef.style.backgroundColor = `rgba(0, 0, 0, ${opacity})`;
        this.shareRef.style.backgroundColor = `rgba(0, 0, 0, ${opacity})`;
      }
    });
    
    if (typeof window !== 'undefined') {
      if (this.navigationRef) {
        window.navigationBarHeight = this.navigationRef.clientHeight - 1;
      }
    }
  }

  backClick = () => {
    if(typeof window !== 'undefined'){
      if (utils.isShihuo()) {
        window.Jockey.send('windowClose');
      } else {
        window.history.back();
      }
    }
  }

  shareClick = () => {
    // 分享埋点
    const pageOptions = {
      component_id: this.props.customAttributes['data-component-id'],
      lego_page_id: this.pageId,
      legoAb: this.props.legoAb
    }
    shihuo.uploadTrack({
      pti: {
        id: 'lego-specialTopic:share',
        name: '导航栏分享',
        biz: JSON.stringify(pageOptions),
        pageOptions
      }
    })

    // 分享交互
    const { shareUrl, shareTitle, shareContent, shareImage } = this.props.config.baseConfig;
    const isStage = window.location.href.indexOf('/stage/page') >= 0;
    let pageRoute = '';
    if (!isStage) {
      pageRoute = `shihuo://www.shihuo.cn?route=fastWebview&navigationBar=false&url=${encodeURIComponent('https://zt-public.shihuo.cn/page/' + this.pageId + '/index.html')}`
    } else {
      pageRoute = `shihuo://www.shihuo.cn?route=fastWebview&navigationBar=false&url=${encodeURIComponent('https://zt-public.shihuo.cn/stage/page/' + this.pageId + '/index.html')}`
    }
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/share/get?access_token=znSnA7pxO35wtPBaur',
      method: "get",
      withCredentials: true,
      params: {
        page_id: this.pageId,
        title: shareTitle,
        desc: shareContent,
        url: pageRoute,
        img: shareImage
      },
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        window.Jockey.send("share", {
          url: `${shareUrl}${shareUrl.indexOf('?') < 0 ? '?' : '&'}kl=${encodeURIComponent(data.kl)}`,
          title: shareTitle,
          content: shareContent,
          img: shareImage,
        });
      }
    })
  }

  render() {
    
    let { navigationBarHeight, navigationBarPaddingTop, backgroundColor } = this.props;
    const { baseConfig } = this.props.config;

    return (
      <div className="navigation-bar-popover" style={{transform: "translate3d(0, -1px, 0)"}} ref={ref => this.navigationRef = ref}>
        <div
          ref={ref => this.ref = ref}
          className="navigation-bar"
          {...this.props['customAttributes']}
          style={{
            paddingTop: navigationBarPaddingTop,
            height: navigationBarHeight,
            backgroundColor: backgroundColor,
          }}
        >
          <div 
            className="main-title"
            style={{
              color: baseConfig.navigatorBarTheme == '白' ? '#fff' : '#333'
            }}
          >
            {window.document.title}
          </div>
        </div>
        <div
          className="share-icon-wrap"
          onClick={this.shareClick}
        >
          <div className="share-icon-bg" ref={ref => this.shareRef = ref}>
            <svg t="1657000501157" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1529" width="24" height="24" className="share-icon-light" ref={ref => this.shareLightRef = ref}>
              <path d="M367.616 128a42.666667 42.666667 0 0 1 4.992 85.034667L367.616 213.333333H235.050667a21.333333 21.333333 0 0 0-20.992 17.493334l-0.341334 3.84v554.666666a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.197333a21.333333 21.333333 0 0 0 20.949333-17.493334l0.384-3.84v-358.912a42.666667 42.666667 0 0 1 85.034667-4.992l0.298667 4.992V789.333333a106.666667 106.666667 0 0 1-99.669334 106.453334l-6.997333 0.213333H235.008a106.666667 106.666667 0 0 1-106.410667-99.669333L128.426667 789.333333v-554.666666a106.666667 106.666667 0 0 1 99.626666-106.453334L235.093333 128h132.565334z m455.552 0a64 64 0 0 1 45.226667 109.226667 42.666667 42.666667 0 0 1-16.042667 10.112c-99.626667 34.858667-180.864 83.968-244.181333 147.285333-62.293333 62.336-101.546667 132.650667-118.442667 211.626667a42.666667 42.666667 0 0 1-83.456-17.834667c20.394667-95.402667 67.84-180.352 141.568-254.122667a665.216 665.216 0 0 1 159.146667-116.565333l8.533333-4.437333L599.637333 213.333333a42.666667 42.666667 0 0 1-42.368-37.674666L556.970667 170.666667a42.666667 42.666667 0 0 1 37.674666-42.368L599.637333 128h223.530667z" p-id="1530" fill="#ffffff"></path>
            </svg>
            <svg t="1657000501157" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1529" width="24" height="24" className="share-icon-dark" ref={ref => this.shareDarkRef = ref}>
              <path d="M367.616 128a42.666667 42.666667 0 0 1 4.992 85.034667L367.616 213.333333H235.050667a21.333333 21.333333 0 0 0-20.992 17.493334l-0.341334 3.84v554.666666a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.197333a21.333333 21.333333 0 0 0 20.949333-17.493334l0.384-3.84v-358.912a42.666667 42.666667 0 0 1 85.034667-4.992l0.298667 4.992V789.333333a106.666667 106.666667 0 0 1-99.669334 106.453334l-6.997333 0.213333H235.008a106.666667 106.666667 0 0 1-106.410667-99.669333L128.426667 789.333333v-554.666666a106.666667 106.666667 0 0 1 99.626666-106.453334L235.093333 128h132.565334z m455.552 0a64 64 0 0 1 45.226667 109.226667 42.666667 42.666667 0 0 1-16.042667 10.112c-99.626667 34.858667-180.864 83.968-244.181333 147.285333-62.293333 62.336-101.546667 132.650667-118.442667 211.626667a42.666667 42.666667 0 0 1-83.456-17.834667c20.394667-95.402667 67.84-180.352 141.568-254.122667a665.216 665.216 0 0 1 159.146667-116.565333l8.533333-4.437333L599.637333 213.333333a42.666667 42.666667 0 0 1-42.368-37.674666L556.970667 170.666667a42.666667 42.666667 0 0 1 37.674666-42.368L599.637333 128h223.530667z" p-id="1530" fill="#000000"></path>
            </svg>
          </div>
        </div>
        <div
          className="back-icon-wrap"
          onClick={this.backClick}
        >
          <div className="back-icon-bg" ref={ref => this.backRef = ref}>
            <svg t="1718692157427" class="back-icon-light" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2761" width="24" height="24" ref={ref => this.backLightRef = ref}><path d="M853.504 170.752a42.666667 42.666667 0 0 1 3.498667 56.32l-3.541334 4.010667-281.6 281.386666 281.6 280.917334a42.666667 42.666667 0 0 1-56.277333 63.957333l-4.010667-3.541333-281.685333-281.002667-281.173333 280.96a42.666667 42.666667 0 0 1-63.829334-56.32l3.541334-4.053333 281.045333-280.874667-281.002667-280.32a42.666667 42.666667 0 0 1 56.234667-64l4.010667 3.584 281.130666 280.448L793.130667 170.666667a42.666667 42.666667 0 0 1 60.373333 0z" fill="#ffffff" p-id="2762"></path></svg>
            <svg t="1718692157427" class="back-icon-dark" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2761" width="24" height="24" ref={ref => this.backDarkRef = ref}><path d="M853.504 170.752a42.666667 42.666667 0 0 1 3.498667 56.32l-3.541334 4.010667-281.6 281.386666 281.6 280.917334a42.666667 42.666667 0 0 1-56.277333 63.957333l-4.010667-3.541333-281.685333-281.002667-281.173333 280.96a42.666667 42.666667 0 0 1-63.829334-56.32l3.541334-4.053333 281.045333-280.874667-281.002667-280.32a42.666667 42.666667 0 0 1 56.234667-64l4.010667 3.584 281.130666 280.448L793.130667 170.666667a42.666667 42.666667 0 0 1 60.373333 0z" fill="#000000" p-id="2762"></path></svg>
          </div>
        </div>
      </div>
    );
  }
}

PipelineNavigationBarPopover.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineNavigationBarPopover };
export default PipelineNavigationBarPopover;



// WEBPACK FOOTER //
// ./templates/luodiye/src/baseComponents/navigation-bar-popover/index.js